'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var classNames = require('classnames');
var withStyles = require('../../Styles/withStyles.js');
var Grid = require('../../Layout/Grid/Grid.js');
var IconButton = require('../../Inputs/Buttons/IconButton.js');
require('prop-types');
var ObjectHelper = require('../../../common/ObjectHelper.js');
var Toolbar$2 = require('../../../node_modules/@material-ui/core/esm/Toolbar/Toolbar.js');
var AppBar = require('../../../node_modules/@material-ui/core/esm/AppBar/AppBar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  var _appearsBelowMainNavM;

  return {
    toolbar: {
      borderBottom: 'solid 1px #e0e0e0'
    },
    toolbarGutters: {
      paddingLeft: 16
    },
    appearsBelowMainNavMargin: (_appearsBelowMainNavM = {
      zIndex: theme.zIndex.appBar - 1
    }, defineProperty(_appearsBelowMainNavM, theme.breakpoints.down('md'), {
      marginTop: 64
    }), defineProperty(_appearsBelowMainNavM, theme.breakpoints.up('md'), {
      marginTop: 72
    }), _appearsBelowMainNavM),
    barEnd: {
      paddingRight: 20,
      minWidth: 64
    },
    leftIconButton: {
      marginLeft: -12,
      marginRight: 4
    },
    toolbarSelected: {
      backgroundColor: '#EEF7FE'
    }
  };
};

var Toolbar = function Toolbar(_ref) {
  var classes = _ref.classes,
      pageTitle = _ref.pageTitle,
      pageTitleProps = _ref.pageTitleProps,
      appearsBelowMainNav = _ref.appearsBelowMainNav,
      leftIcon = _ref.leftIcon,
      leftIconAction = _ref.leftIconAction,
      centerChildren = _ref.centerChildren,
      children = _ref.children,
      position = _ref.position,
      elevation = _ref.elevation,
      className = _ref.className,
      color = _ref.color,
      version = _ref.version,
      restOfProps = objectWithoutProperties(_ref, ["classes", "pageTitle", "pageTitleProps", "appearsBelowMainNav", "leftIcon", "leftIconAction", "centerChildren", "children", "position", "elevation", "className", "color", "version"]);

  var toolbarChildren = function toolbarChildren() {
    return children.map(function (child, index) {
      if (!ObjectHelper.isPresent(child)) {
        return null;
      } // Tooltips wrap ALL IconButtons. IconButtons don't need extra margin


      if (ObjectHelper.isPresent(child.type) && child.type.name === 'Tooltip') {
        return React__default["default"].createElement(Grid, {
          item: true,
          key: index
        }, child);
      } // This puts extra margin on items that aren't IconButtons. Except the last one so the spacing on the right is correct


      return React__default["default"].createElement(Grid, {
        item: true,
        key: index
      }, React__default["default"].createElement("div", {
        style: {
          marginLeft: 12,
          marginRight: index === children.length - 1 ? 0 : 12
        }
      }, child));
    });
  };

  var renderChildren = function renderChildren() {
    if (!ObjectHelper.isPresent(children)) {
      return null;
    }

    if (Array.isArray(children)) {
      return toolbarChildren();
    }

    if (React__default["default"].isValidElement(children)) {
      return React__default["default"].createElement(Grid, {
        item: true
      }, children);
    }

    return null;
  };

  if (version === 'v2') {
    return React__default["default"].createElement(Toolbar$2["default"], _extends["default"]({
      color: color,
      className: className
    }, restOfProps), children);
  } else {
    var _classNames;

    return React__default["default"].createElement(AppBar["default"], _extends["default"]({
      position: position,
      color: color === 'toolbarSelected' ? undefined : color,
      className: classNames__default["default"](className, classes.toolbar, (_classNames = {}, defineProperty(_classNames, classes.appearsBelowMainNavMargin, appearsBelowMainNav === true), defineProperty(_classNames, classes.toolbarSelected, color === "toolbarSelected"), _classNames)),
      elevation: elevation
    }, restOfProps), React__default["default"].createElement(Grid, {
      container: true,
      alignItems: "center",
      justify: "space-between"
    }, React__default["default"].createElement(Grid, {
      item: true
    }, React__default["default"].createElement(Toolbar$2["default"], {
      classes: {
        gutters: classes.toolbarGutters
      }
    }, ObjectHelper.isPresent(leftIcon) && React__default["default"].createElement(IconButton, {
      className: classes.leftIconButton,
      onClick: leftIconAction,
      color: "inherit"
    }, leftIcon), React__default["default"].createElement(Typography, _extends["default"]({
      variant: "h5",
      color: color === "toolbarSelected" ? 'primary' : 'inherit'
    }, pageTitleProps), pageTitle))), centerChildren && React__default["default"].createElement(Grid, {
      item: true
    }, centerChildren), React__default["default"].createElement(Grid, {
      item: true,
      className: classes.barEnd
    }, React__default["default"].createElement(Grid, {
      container: true,
      alignItems: "center",
      justify: "flex-end"
    }, renderChildren()))));
  }
};

Toolbar.defaultProps = {
  pageTitle: '',
  pageTitleProps: {},
  appearsBelowMainNav: false,
  leftIcon: null,
  leftIconAction: function leftIconAction() {},
  position: 'fixed',
  elevation: 0,
  color: 'primary'
};
var Toolbar$1 = withStyles["default"](styles)(Toolbar);

module.exports = Toolbar$1;
